import gpsMapController from './gpsMap.controller';
import gpsMapView from './gpsMap.view.html';
import './gpsMap.scss';

const gpsMapComponent = {
  template: gpsMapView,
  controller: gpsMapController,
  controllerAs: 'vm'
};

export default gpsMapComponent;


// WEBPACK FOOTER //
// ./src/components/gpsMap/gpsMap.component.js